import React from "react";
import SectionTitle from "../../atoms/sectionTitle";

import { A11y, Autoplay, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "./index.css";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

import { SwiperOptions } from "swiper/types/swiper-options";
import Footer from "../footer";

interface IPartnerSection {}

type TPartnerSectionProps = IPartnerSection & SwiperOptions;

const PartnersImages = [
  {
    title: "Savils",
    image: require("../../../assets/images/partner_savills.png"),
  },
  {
    title: "Go Swap",
    image: require("../../../assets/images/partner_goSwap.png"),
  },
  {
    title: "AI Parking Bees",
    image: require("../../../assets/images/partner_parkingbees.png"),
  },
  // {
  //   title: "HKPC",
  //   image: require("../../../assets/images/partner_hkpc.png"),
  // },
] as const;

const PartnerSection: React.FC<TPartnerSectionProps> = (props) => {
  const { ...otherProps } = props;

  return (
    <div className="w-full justify-center flex flex-col" {...otherProps}>
      <div className="flex flex-col h-full justify-center">
        <SectionTitle chineseTitle="合作伙伴" englishTitle="Partners" />
        {/* desktop display */}
        <div className="hidden laptop:flex justify-center gap-10">
          {PartnersImages.map((slide) => {
            return (
              <div key={slide.title} className="flex justify-center">
                <img
                  className="max-w-full object-contain opacity-70"
                  src={slide.image}
                  alt={slide.title}
                />
              </div>
            );
          })}
        </div>

        <Swiper
          className="flex justify-center items-center mt-5 mx-8 laptop:hidden"
          slidesPerGroup={2}
          spaceBetween={8}
          slidesPerView={2}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
          }}
          pagination={{
            clickable: true,
            el: ".custom-pagination",
          }}
          modules={[Autoplay, Pagination, A11y]}
          // effect={"coverflow"}
          {...otherProps}
        >
          {PartnersImages.map((slide) => (
            <SwiperSlide key={slide.title} className="flex">
              <img
                className="object-contain aspect-video opacity-70"
                src={slide.image}
                alt={slide.title}
              />
            </SwiperSlide>
          ))}
          {/* <div className="custom-pagination"></div> */}
        </Swiper>
      </div>
      <Footer />
    </div>
  );
};

export default PartnerSection;
